import React, { Component } from 'react';
import {
    // BrowserRouter as Router,
    Link
} from 'react-router-dom';
import AWS from 'aws-sdk';
import './maindefinitions.css';
import './BasicTables.css';



class RoastedOfferingsPage extends Component {

	constructor(props) {
    super(props);
		this.state = {
			lotsTable: null
		};


  //    this.handleChange = this.handleChange.bind(this);
      this.handleAddToCart = this.handleAddToCart.bind(this);
			this.handleChange = this.handleChange.bind(this);
  }

	//Using the array lotQuants to store quantities adds complexity (stringify<->)
	// but keeps state clean without leaving unused vars as offers list shrinks
	// parse int is necessary as the input is read as a string.
	handleChange(event) {
		let newQuants = JSON.parse(JSON.stringify(this.state.lotQuants));
		newQuants[event.target.name] = parseInt(event.target.value, 10);
		console.log(newQuants);
    this.setState({
			lotQuants: newQuants
		});
  }

  componentDidMount() {

    this.props.auth.currentCredentials()
      .then(credentials => {
        const dynamodb = new AWS.DynamoDB.DocumentClient({
          region: 'us-east-1',
          credentials: this.props.auth.essentialCredentials(credentials)
        });
        var params = {
          TableName: 'RoastedLots'
        };

        dynamodb.scan(params, (err, data) => {
          if (err) {
            console.log(err);
            return null;
          } else {
						let quants = new Array(data.Items.length);
            this.setState({
              lotsTable: data.Items,
							lotQuants: quants.fill(1)
            });
          }
        });
    })
	  .catch(error => {
		console.log(error);
	});
  }

	handleAddToCart(event) {
		event.preventDefault();
		const index = event.target.name
    const chosenLot = this.state.lotsTable[index];
		const newCartItem = [
					chosenLot.description,
					chosenLot.id,
					chosenLot.roastTime
			];

		//Reinitializing credentials not really necessary, fix it to initialize once
		// on component componentDidMount and do it again only if creditials are not null
		this.props.auth.currentCredentials()
      .then(credentials => {
				const dynamodb = new AWS.DynamoDB.DocumentClient({
          region: 'us-east-1',
          credentials: this.props.auth.essentialCredentials(credentials)
        });
        var params = {
          ExpressionAttributeValues: {
						// ':newItem': {
            //   "TA-3593b20190401BBB":
            //        [
            //           newCartItem
            //       ]
            // },
             ':newItem': newCartItem,
             ':zero': 0,
             ':quant': this.state.lotQuants[index],
            //':emptyMap': {[chosenLot.id] : [0]}
					},
          Key: {
            'cartId' : this.props.authData.attributes.sub
          },
          //UpdateExpression: "SET #items.#itemId.#qtt = if_not_exists(#items.#itemId.#qtt, :emptyItem) + :inc, #items.#itemId.#desc = :newItem",
          UpdateExpression: 'SET #itemId = if_not_exists(#itemId, :zero) + :quant, #itemInfo = :newItem',
          //UpdateExpression: 'SET #items.#itemId = if_not_exists(#items.#itemId, list_append(:one, :newItem)',//if_not_exists(#items, :emptyMap), #items.#itemId = if_not_exists(#items.#itemId, newItem)',
          ExpressionAttributeNames: {
            //'#items': 'items',
            '#itemId': chosenLot.id,
            '#itemInfo': chosenLot.id + 'info',
            // '#qtt': 'quantity',
            // '#desc': 'description'
          },
          // KeyConditionExpression: '#id = :id' ,
          TableName: 'RoastedCart'
        };

        dynamodb.update(params, (error, data) => {
          if (error) {
            console.log(error);
            return null;
          } else {
            alert("Added item to cart!");
            console.log('Wrote data to DynamoDB');
            console.log (data);
          }
        });
    });
	}

  render() {

	var offerings;
		if (this.state.lotsTable) {
			offerings = this.state.lotsTable.map((doc, index) => {
        var roastDate = new Date(doc.roastTime * 1000);
				return (
					<tr key={doc.id}>
                        <td className='pagetitle2'> {doc.name}</td>
                        <td> {doc.description}</td>
						<td> {doc.id}</td>
						<td> {roastDate.toDateString()}</td>

		        <td> R${this.props.authData && doc.price} / 250g</td>
                        <td className="basicforms">
							{this.props.authData &&
                                <input type="number" name={index} value={this.state.lotQuants[index]} onChange={this.handleChange} min="1" />
							}
						</td>
						<td className="basicformsSmall">
	            {this.props.authData &&
                <input type="button" name={index} value="Adicionar ao carrinho" onClick={this.handleAddToCart} />
	            }
	    				{!this.props.authData && <Link to="/signin">Log In to Order</Link>}
	            </td>

					</tr>


				);
			});
		} else {
			offerings = <tr><td>No Items</td></tr>;
		}

	   return (
		   <div >
				<div className='textsnarrow'>
                   <p className="pagetitle">Encomende aqui</p>
                   <h3>Os cafés serão entregues em aproximadamente 5 dias após a data da torra. Escolha a quantidade desejada e se você prefere em grãos ou moído. </h3>
                   <p> O pagamento será feito na retirada (por enquanto, estamos disponibilizando café apenas para famílias do Colégio Sidarta, contribuindo para arrecadação de recursos para o projeto Andoriar). </p>
        		</div>

		   		<div className="col-75 basic-table-container">
		   			<table className="basic-table">
						<tbody>
							<tr>
                <th>Lote</th>
                <th>Descricao</th>
	   						<th>id</th>
								<th>Data da Torra</th>
	   						<th>Preço</th>
								<th>Qtd</th>
	   						<th></th>
							</tr>
							{offerings}
						  </tbody>
					</table>
				</div>
		   </div>
    );
  }
}

export default RoastedOfferingsPage;



// WEBPACK FOOTER //
// ./src/components/RoastedOfferingsPage.js